const items = [
  "Precision Reimagined",
  "Zero Added Bulk",
  "MagSafe Native",
  "Ultra-Thin Stylus",
  "Flush Magnetic Channel",
  "Pro-Grade Accuracy",
];

export const Marquee = () => (
  <div data-testid="marquee" className="border-y border-stone-200 py-5 overflow-hidden bg-stone-100/60">
    <div className="marquee-track flex whitespace-nowrap w-max">
      {[...items, ...items].map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-2xl md:text-3xl text-stone-800 px-8">{t}</span>
          <span style={{ color: "#E63946" }} className="text-xl">&#9679;</span>
        </span>
      ))}
    </div>
  </div>
);
